var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#13295B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.637 4.455a2 2 0 0 1 2-2h10.727a2 2 0 0 1 2 2v10.727a2 2 0 0 1-2 2H3.637a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#13295B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.273.818v3.273M5.727.818v3.273m-4.09 3.272h14.727"
  })));
};
export { SvgCalendarIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSI+PHBhdGggc3Ryb2tlPSIjMTMyOTVCIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xLjYzNyA0LjQ1NWEyIDIgMCAwIDEgMi0yaDEwLjcyN2EyIDIgMCAwIDEgMiAydjEwLjcyN2EyIDIgMCAwIDEtMiAySDMuNjM3YTIgMiAwIDAgMS0yLTJWNC40NTVaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBzdHJva2U9IiMxMzI5NUIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTEyLjI3My44MTh2My4yNzNNNS43MjcuODE4djMuMjczTTEuNjM3IDcuMzYzaDE0LjcyNyIvPjwvc3ZnPg==";